import React from 'react';
import { FadeIn } from './FadeIn';
import { Download, ShieldCheck, FileText, Flame } from 'lucide-react';
export function PricingSection() {
  return <section className="bg-white py-16 px-6 md:px-12 lg:px-24" data-id="element-96">
      <div className="max-w-2xl mx-auto text-center" data-id="element-97">
        <FadeIn data-id="element-98">
          <h2 className="text-2xl md:text-3xl font-bold text-text-gray mb-6 uppercase tracking-widest" data-id="element-99">
            Tu inversión hoy:
          </h2>
        </FadeIn>

        {/* Discount badge */}
        <FadeIn delay={0.15} data-id="element-100">
          <div className="flex justify-center mb-6" data-id="element-101">
            <span className="bg-red-500 text-white font-bold text-lg md:text-xl px-6 py-3 rounded-full shadow-lg flex items-center gap-2" data-id="element-102">
              <Flame size={20} data-id="element-103" />
              79% DE DESCUENTO — TIEMPO LIMITADO
            </span>
          </div>
        </FadeIn>

        {/* Regular price strikethrough */}
        <FadeIn delay={0.25} data-id="element-104">
          <p className="text-lg text-text-gray mb-2 uppercase tracking-wider" data-id="element-105">
            Precio Regular
          </p>
          <p className="text-4xl md:text-5xl font-bold text-red-500/70 line-through decoration-red-500 decoration-4 mb-6" data-id="element-106">
            $34
          </p>
        </FadeIn>

        {/* Sale price */}
        <FadeIn delay={0.35} data-id="element-107">
          <p className="text-lg text-text-gray mb-3 uppercase tracking-wider font-bold" data-id="element-108">
            Solo hoy:
          </p>
          <p className="text-8xl md:text-9xl font-bold text-sage mb-4" data-id="element-109">
            <span className="font-sans" data-id="element-110">$</span>
            <span className="font-serif" data-id="element-111">7</span>
          </p>
        </FadeIn>

        {/* No subscription text */}
        <FadeIn delay={0.45} data-id="element-112">
          <div className="mb-10" data-id="element-113">
            <p className="text-xl md:text-2xl text-text-black font-medium" data-id="element-114">
              Un solo pago.
            </p>
            <p className="text-xl md:text-2xl text-text-black font-medium" data-id="element-115">
              Sin suscripciones. <span className="font-bold" data-id="element-116">Jamás.</span>
            </p>
          </div>
        </FadeIn>

        {/* Value callout box */}
        <FadeIn delay={0.5} data-id="element-117">
          <div className="border-2 border-gold bg-gold-light rounded-xl py-4 px-6 mb-12 inline-block" data-id="element-118">
            <p className="text-xl md:text-2xl font-serif font-bold text-dark-green" data-id="element-119">
              Obtén $34 en valor por solo $7
            </p>
          </div>
        </FadeIn>

        {/* CTA Button */}
        <FadeIn delay={0.55} data-id="element-120">
          <a href="#comprar" className="w-full md:w-auto bg-sage hover:bg-dark-green text-white text-xl md:text-2xl font-bold py-6 px-10 rounded-full shadow-xl transform transition-all duration-300 hover:scale-105 hover:shadow-2xl flex items-center justify-center gap-2 mx-auto mb-10 no-underline" data-id="element-121">
            <span data-id="element-122">👆 QUIERO DESCARGAR MI COPIA AHORA POR SOLO $7</span>
          </a>
        </FadeIn>

        {/* Trust badges */}
        <FadeIn delay={0.65} data-id="element-123">
          <div className="flex flex-col md:flex-row items-center justify-center gap-6 text-text-gray text-sm md:text-base" data-id="element-124">
            <div className="flex items-center gap-2" data-id="element-125">
              <ShieldCheck size={20} className="text-sage" data-id="element-126" />
              <span data-id="element-127">Pago seguro por Stripe</span>
            </div>
            <div className="hidden md:block text-gold" data-id="element-128">•</div>
            <div className="flex items-center gap-2" data-id="element-129">
              <Download size={20} className="text-sage" data-id="element-130" />
              <span data-id="element-131">Descarga instantánea</span>
            </div>
            <div className="hidden md:block text-gold" data-id="element-132">•</div>
            <div className="flex items-center gap-2" data-id="element-133">
              <FileText size={20} className="text-sage" data-id="element-134" />
              <span data-id="element-135">PDF para cualquier dispositivo</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}